/**
 * CEL Site Header Scripts
 *
 * This script handles various functionalities for the CEL site header.
 *
 * It includes:
 * - Managing focus on search input for screen reader "Jump to Search" link.
 * - Toggling overflow class to handle scrolling behavior on mobile navigation.
 * - Handling smooth animations for mobile dropdown menus.
 * - Moving secondary navigation items between containers based on screen size.
 *
 * This script relies on jQuery and Bootstrap's JavaScript components.
 */
 
// Import the mobileNavBreakpoint constant
import { mobileNavBreakpoint } from '../config/constants';

// jQuery ready function
$(function() {
	
	// Handle click event for the "Jump to Search" link
	// Prevents default link behavior and focuses the search input
	$('#jumpToSearch').click((e) => {
		e.preventDefault();
		$('#celSiteSearchInput').focus();
	});
	
	// Toggle .hide-overflow class on the <html> element for mobile navigation
	// This class hides overflow and disables scrolling when the mobile nav is open
	const $siteMobileNavToggle = $('#siteMobileNavToggle');
	$siteMobileNavToggle.click(() => {
		if ($siteMobileNavToggle.hasClass('collapsed')) {
			$('html').addClass('hide-overflow');
		} else {
			$('html').removeClass('hide-overflow');
		}
	});
	
	// Mobile menu dropdown animations
	// Adds and removes custom classes during animation to handle smooth transitions
	$('#siteNavContent .dropdown, #bookMenu .dropdown').on('show.bs.dropdown hide.bs.dropdown', (e) => {
		if ($(window).width() < mobileNavBreakpoint) {
			const $dropdownMenu = $(e.currentTarget).find('.dropdown-menu');
	
			if (e.type === 'show') {
				$dropdownMenu.addClass('opening').slideDown('fast').promise().done(() => {
					$dropdownMenu.removeClass('opening').css('display', '');
				});
			} else {
				$dropdownMenu.addClass('closing').slideUp('fast').promise().done(() => {
					$dropdownMenu.removeClass('closing').css('display', '');
				});
			}
		}
	});
	
	// Move secondary navigation items based on screen size
	// Moves .menu-item elements between primary and secondary nav containers
	const moveSecondaryNav = () => {
		const windowWidth = $(window).width();
		const $secondaryNavContainer = $('#siteSecondaryNav .nav');
		const $primaryNavContainer = $('#siteNavContent .navbar-nav');
		const secondaryNavItem = '.menu-item';
		
		if (windowWidth >= mobileNavBreakpoint) {
			$primaryNavContainer.find(secondaryNavItem).appendTo($secondaryNavContainer);
		} else {
			$secondaryNavContainer.find(secondaryNavItem).appendTo($primaryNavContainer);
		}
	};
	
	// Attach the resize event listener to update nav positions on window resize
	$(window).resize(moveSecondaryNav);
	
	// Initial call to position the nav items correctly on page load
	moveSecondaryNav();
	
});